import tw from 'tailwind-styled-components'

const PaddingStep = 24

export const TwTreeList = tw.div`
  pl-12
  py-8
`

export const TwSearchWrapper = tw.div`
  pt-4
  pb-8
  pr-12
`

export const TreeListWrapper = tw.div`
  max-h-300
`

export const TwList = tw.div<{$level?: number}>`
  ${({$level}) => ($level ? `pl-${$level * PaddingStep}` : '')}
`

export const TwEmptyList = tw.div`
  w-full
  text-center
  text-primary
`

export const TwListItem = tw.div`
  w-full
  flex
  py-4
  pr-12
  gap-8
  items-center
`

export const TwListItemTitle = tw.div`
  w-full
  py-4
  text-primary
`

export const TwListItemText = tw.span``

export const TwListItemHighlighted = tw.span`
  font-semibold
`
